import { Injectable } from '@angular/core';
import { Globals } from '../globals';
import { map } from "rxjs/operators";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiAuthService } from './api-auth.service';
import { isNullOrUndefined } from 'util';

@Injectable({
  providedIn: 'root'
})
export class ApiUploadFileService {
  private headers: HttpHeaders;

  constructor(public globals: Globals, private httpApi: HttpClient, private apiAuth: ApiAuthService) { }

  postFile(correo: string, mov: string, cveproc: string,tipoproc: string, cvedoc: string, goddocs: string, comentarios: string, archivo: File) {
    this.actualizaHeader();
    const formData = new FormData();
    formData.append('fileUpload', archivo, archivo.name);
    return this.httpApi.post(this.globals.BASE_URL + `RegistroABCDocsProveedor_E?idUsuario=&VPN_MOV=${ mov }&VPN_CVEPROC=${ cveproc }&VPS_TIPOPROC=${ tipoproc }&VPS_CVEDOC=${ cvedoc }&VPN_GODDOCS=${ goddocs }&VPS_COMENT=${ comentarios }`, formData, { headers: this.headers });
  }

  deleteFile(correo: string, mov: string, cveprov: string,tipoprov: string, cvedoc: string, goddocs: string) {
    this.actualizaHeader();
    let httpParams = new HttpParams()
                .append("idUsuario", '')
                .append("VPN_MOV", mov)
                .append("VPN_CVEPROC", cveprov)
                .append("VPS_TIPOPROC", tipoprov)
                .append("VPS_CVEDOC", cvedoc)
                .append("VPN_GODDOCS", goddocs);
    return this.httpApi.post(this.globals.BASE_URL + `RegistroABCDocsProveedor_E`, httpParams, { headers: this.headers })
                        .pipe(map(data => data));
  }

  private actualizaHeader() {
    let token = this.apiAuth.getToken() !== null ? this.apiAuth.getToken().replace(/["\\]/g, '') : '';
    token = token.replace(/["\\]/g, '');
    this.headers = new HttpHeaders({
      "Authorization": 'Bearer ' + token
    });
  }

  postAnexoTecnico(movimiento: string, anio: string, idProcedimiento: string, idPartida: string, idProveedor: string, GodDocsDelete: string,
    file: File, idUsuario: string) {
    this.actualizaHeader();

    let formData = new FormData();

    if (movimiento == 'U'){
      formData.append('fileUpload', file, file.name);
    } else {
      formData = null;
    }

    return this.httpApi.post(this.globals.BASE_URL + `uploadFilePartidasProv_E?movimiento=${ movimiento }&anio=${ anio }&idProcedimiento=${ idProcedimiento }&` +
                  `idPartida=${ idPartida }&idProveedor=${ idProveedor }&GodDocsDelete=${ GodDocsDelete }&idUsuario=${ idUsuario }`, formData,
                  {headers: this.headers});
  }

  postFileObraProcProv(usuario: string, mov: string, anio: string, proc: string, cveproc: string, tipoproc: string, cvedoc: string, goddocs: string, comentarios: string, archivo: File) {
    this.actualizaHeader();
    const formData = new FormData();
    formData.append('fileUpload', archivo, archivo.name);
    return this.httpApi.post(this.globals.BASE_URL + `registroABCDocsProcProveedor_E?idUsuario=&VPN_MOV=${ mov }&VPN_ANIO=${ anio }&VPN_PROC=${ proc }&VPN_CVEPROC=${ cveproc }&VPS_TIPOPROC=${ tipoproc }&VPS_CVEDOC=${ cvedoc }&VPN_GODDOCS=${ goddocs }&VPS_COMENT=${ comentarios }`, formData, { headers: this.headers });
  }

  deleteFileObraProcProv(usuario: string, mov: string, anio: string, proc: string, cveproc: string, tipoproc: string, cvedoc: string, goddocs: string) {
    this.actualizaHeader();
    let httpParams = new HttpParams()
                .append("idUsuario", '')
                .append("VPN_MOV", mov)
                .append("VPN_ANIO", anio)
                .append("VPN_PROC", proc)
                .append("VPN_CVEPROC", cveproc)
                .append("VPS_TIPOPROC", tipoproc)
                .append("VPS_CVEDOC", cvedoc)
                .append("VPN_GODDOCS", goddocs);

    return this.httpApi.post(this.globals.BASE_URL + `registroABCDocsProcProveedor_E`, httpParams, { headers: this.headers })
                        .pipe(map(data => data));
  }

  uploadFacturas(anio: string, idProcedimiento: string, movimiento: string, PK_Fadenli: string, archivoPDF?: File, archivoXML?: File, archivoJPG?: File){
    this.actualizaHeader();

    let usuario = this.apiAuth.getTokenDecoded();
    let RFC;
    let formData = new FormData();

    if (isNullOrUndefined(usuario)) {
      RFC = "Publico";
    } else {
      RFC = usuario.RFC;
    }

    if (movimiento === this.globals.MOVTO_ALTA_FACTURA) {
      formData.append('PDF', archivoPDF, archivoPDF.name);
      formData.append('xml', archivoXML, archivoXML.name);
      //formData.append('imgverif', archivoJPG, archivoJPG.name);
    }

    return this.httpApi.post(this.globals.BASE_URL + 'ABC_Factura_E?anio=' + anio + '&idProcedimiento=' + idProcedimiento + '&PK_Fadenli='+ PK_Fadenli +
                                                    '&movimiento=' + movimiento + '&idUsuario=' + RFC, formData, {headers: this.headers})
      .pipe(map(data => data));
  }

  declinaPartidas(anio: string, idProcedimiento: string, idPartida: string, idProveedor: string, file: File){
    this.actualizaHeader();

    let usuario = this.apiAuth.getTokenDecoded();
    let RFC;
    let formData = new FormData();

    formData.append('fileUpload', file, file.name);

    if (isNullOrUndefined(usuario)) {
      RFC = "Publico";
    } else {
      RFC = usuario.RFC;
    }

    return this.httpApi.post(this.globals.BASE_URL_PROCS + 'declinaPartidas_E?anio=' + anio + '&idProcedimiento=' + idProcedimiento + '&idPartida='+ idPartida +
                                                    '&idProveedor=' + idProveedor + '&idUsuario=' + RFC, formData, {headers: this.headers})
      .pipe(map(data => data));
  }
}
